class DateManager {
    static mode = {
        '物件': 0,
        '字串(datetime)': 1,
        '字串(date)': 2
    }
    pipe = []
    date = null
    constructor(date){
        this.set_date(date);
        this.set_mode(DateManager.mode["字串(datetime)"]);
    }

    set_date(date){
        if(date instanceof Date){
            // console.log('物件')
            this.date = date
        }
        else if(typeof(date) === 'string'){
            // console.log('字串')
            const rs = [
                RegExp(/([0-9]{4})-([0-9]{1,2})-([0-9]{1,2}) ([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})/),
                RegExp(/([0-9]{4})\/([0-9]{1,2})\/([0-9]{1,2}) ([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})/),
                RegExp(/([0-9]{4})([0-9]{1,2})([0-9]{1,2})/),
                RegExp(/([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})/),
                RegExp(/([0-9]{4})\/([0-9]{1,2})\/([0-9]{1,2})/),
                RegExp(/.*台北標準時間.*/)
            ]
            for(let i = 0; i < rs.length; i++){
                const r = rs[i]
                const found = date.match(r)
                // console.log(found)
                if(found && found.length > 1){
                    found.splice(0, 1)
                    found[1] = found[1] > 0 ? found[1] - 1 : 0
                    this.date = new Date(...found)
                    break
                }
                else{
                    this.date = new Date(date)
                }
            }
            // console.log(this.date)
        }
        else if(typeof(date) === 'number'){
            this.date = new Date(date)
        }
        else{
            // console.log('空')
            this.date = new Date()
        }
    }

    _pipe_date(dt){
        const year = dt.getFullYear().toString().padStart('4', '0')
        const month = (dt.getMonth() + 1).toString().padStart('2', '0')
        const day = dt.getDate().toString().padStart('2', '0')
        const date = `${year}-${month}-${day}`
        
        return date
    }

    _pipe_datetime(dt){
        const year = dt.getFullYear().toString().padStart('4', '0')
        const month = (dt.getMonth() + 1).toString().padStart('2', '0')
        const day = dt.getDate().toString().padStart('2', '0')
        const hour = dt.getHours().toString().padStart('2', '0')
        const minute = dt.getMinutes().toString().padStart('2', '0')
        const second = dt.getSeconds().toString().padStart('2', '0')
        const datetime = `${year}-${month}-${day} ${hour}:${minute}:${second}`
        
        return datetime
    }

    set_mode(mode){
        this.pipe.splice(0, this.pipe.length)
        if(mode === 1){
            this.pipe.push(this._pipe_datetime)
        }
        else if(mode === 2){
            this.pipe.push(this._pipe_date)
        }
    }

    now(){
        let res = this.date
        this.pipe.forEach(p=>{
            res = p(res)
        })

        return res
    }
    
    add(year, month, day, hour, minute, second){
        if(!year) year = 0
        if(!month) month = 0
        if(!day) day = 0
        if(!hour) hour = 0
        if(!minute) minute = 0
        if(!second) second = 0
        
        let res = this.date
        res.setFullYear(
            res.getFullYear() + year,
            res.getMonth() + month,
            res.getDate() + day
        )
        res.setHours(
            res.getHours() + hour,
            res.getMinutes() + minute,
            res.getSeconds() + second
        )
        this.pipe.forEach(p=>{
            res = p(res)
        })

        return res
    }

    static diff(dm1, dm2){
        if(typeof(dm1) === 'number' && typeof(dm2) === 'number'){
            return new DateManager(dm2 - dm1)
        }
        else if(typeof(dm1) === 'string' && typeof(dm2) === 'string'){
            return new DateManager(new DateManager(dm1).date - new DateManager(dm2).date)
        }
        else if(dm1 instanceof Date && dm2 instanceof Date){
            return new DateManager(dm2 - dm1)
        }
        else if(dm1 instanceof DateManager && dm2 instanceof DateManager){
            return new DateManager(dm2.date - dm1.date)
        }
        else{
            throw '<error>(class)[DateManager]: diff -> dm1, dm2型態錯誤'
        }

        
    }

    static compare(dm1, dm2){
        if(typeof(dm1) === 'number' && typeof(dm2) === 'number'){
            dm1 = new DateManager(dm1)
            dm2 = new DateManager(dm2)
        }
        else if(typeof(dm1) === 'string' && typeof(dm2) === 'string'){
            dm1 = new DateManager(dm1)
            dm2 = new DateManager(dm2)
        }
        else if(dm1 instanceof Date && dm2 instanceof Date){
            dm1 = new DateManager(dm1)
            dm2 = new DateManager(dm2)
        }
        
        if(dm1.date.getTime() == dm2.date.getTime()) return 0
        if(dm1.date.getTime() < dm2.date.getTime()) return -1
        if(dm1.date.getTime() > dm2.date.getTime()) return 1
    }

    static now_date(s){
        const dm = new DateManager(s)
        dm.set_mode(DateManager.mode['字串(date)'])
        return dm.now()
    }

    static test(dm){
        // console.log('----------------- test ouput -----------------')
        dm.set_mode(DateManager.mode['字串(date)'])
        // console.log('now: ', dm.now())
        // console.log('add: ', dm.add(0, 0, 0, -10, -5, -21))
    }
}

export default DateManager